import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=5a167356&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"
import style0 from "./blackList.vue?vue&type=style&index=0&id=5a167356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a167356",
  null
  
)

export default component.exports